@use "@fukuri-admins/ui/layout" as *;

.noCol             { width: 80px; }
.emailCol          { white-space: nowrap; }
.nameCol           { white-space: nowrap; }
.loginCol          { width: 100px; }
.activationCodeCol { width: 200px; }
.branchNameCol     { width: 200px; }
.branchCodeCol     { width: 200px; }
.billableFromCol   { @include colDate; }
.createdAtCol      { @include colDateTime; }
.actionCol         { @include colAction; }

.emailCell,
.nameCell {
  white-space: nowrap;
}

// アクティベーションコードのレイアウト（legacy 踏襲）
.activationCode {
  display: flex;
  align-items: center;
  gap: spacing("4");
}

.deleteItem {
  color: text('Red');
}
